import styled from "styled-components";
import { Flex } from "antd";

export const StyledHalfWidthFlex = styled(Flex).attrs({
  vertical: true,
  gap: 20,
})`
  width: 50%;
`;

export const StyledWrapper = styled(Flex).attrs({
  gap: 30,
})`
  width: 80%;
  margin: 5px 20px;
`;
